import React from "react";

import "./styles/footer.css";
import logo from "../assets/pfs_logo.png";
import DiscordButton from "./DiscordButton";

// Closed set of link columns. Treated as the component's static, trusted
// content contract; each href is a fixed literal (no user input rendered).
const LINK_COLUMNS = [
    {
        heading: "Navigation",
        links: [
            { label: "Home", href: "/" },
            { label: "Leaderboard", href: "/leaderboard" },
            { label: "Store", href: "https://store.paramore.net/" },
        ],
    },
    {
        heading: "Community",
        links: [
            { label: "Paracord", href: "http://discord.gg/paramorefanserver" },
            { label: "Members", href: "/leaderboard" },
        ],
    },
    {
        heading: "Paramore",
        links: [
            { label: "X / Twitter", href: "https://twitter.com/paramore" },
            { label: "Instagram", href: "https://instagram.com/paramore" },
            { label: "Official Site", href: "https://www.paramore.net/" },
        ],
    },
];

const Footer = () => {
    return (
        <footer className="footer-root">
            <span className="footer-watermark" aria-hidden="true">
                paramore
            </span>

            <div className="footer-inner">
                <div className="footer-brand">
                    <div className="footer-brand-head">
                        <img
                            className="footer-logo"
                            src={logo}
                            alt="Paramore Fan Server logo"
                        />
                        <span className="footer-brand-name">Paramore Fan Server</span>
                    </div>

                    <p className="footer-disclaimer">
                        This website does not represent or have any affiliation with the
                        band Paramore. We are just fans who want to chat about our
                        favorite band.
                    </p>

                    <p className="footer-copyright">Paramore Fan Server &copy; 2025</p>

                    <div className="footer-cta">
                        <DiscordButton />
                    </div>
                </div>

                <nav className="footer-columns" aria-label="Footer">
                    {LINK_COLUMNS.map((column) => (
                        <div className="footer-column" key={column.heading}>
                            <span className="footer-column-heading">{column.heading}</span>
                            {column.links.map((link) => (
                                <a
                                    className="footer-link"
                                    key={link.label}
                                    href={link.href}
                                >
                                    {link.label}
                                </a>
                            ))}
                        </div>
                    ))}
                </nav>
            </div>
        </footer>
    );
};

export default Footer;
